export function popoverPosition(anchor,size,viewport){
  const margin=12,gap=8,width=Math.min(size.width,Math.max(0,viewport.width-margin*2));
  const below=Math.max(0,viewport.height-anchor.bottom-gap-margin),above=Math.max(0,anchor.top-gap-margin);
  const up=below<Math.min(size.height,440)&&above>below;
  const maxHeight=Math.min(440,up?above:below),height=Math.min(size.height,maxHeight);
  const left=Math.max(margin,Math.min(anchor.left+(anchor.right-anchor.left-width)/2,viewport.width-margin-width));
  const top=Math.max(margin,Math.min(up?anchor.top-gap-height:anchor.bottom+gap,viewport.height-margin-height));
  return {left,top,width,maxHeight};
}
